// extracted by mini-css-extract-plugin
export default {"label":"style_label__GUk85","c":"style_c__msKYG","e":"style_e__c0q0R","icon":"style_icon__T+7ao"};